var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.024C14.9865 13.024 17.8551 10.1995 17.8551 6.66896C17.8551 3.1825 14.9865 0.313904 11.5 0.313904C7.96944 0.313904 5.14497 3.1825 5.14497 6.66896C5.14497 10.1995 7.96944 13.024 11.5 13.024ZM17.149 14.4362H14.6775C13.7066 14.9217 12.6475 15.1424 11.5 15.1424C10.3526 15.1424 9.24927 14.9217 8.27836 14.4362H5.85108C2.71769 14.4362 0.202148 16.9959 0.202148 20.0852V20.7913C0.202148 21.9829 1.12893 22.9096 2.3205 22.9096H20.6795C21.827 22.9096 22.7979 21.9829 22.7979 20.7913V20.0852C22.7979 16.9959 20.2382 14.4362 17.149 14.4362Z",
    fill: "#4AB3FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportActive);
export default __webpack_public_path__ + "static/media/supportActive.099ed251764832694cf838f26f58723e.svg";
export { ForwardRef as ReactComponent };